<div class="content-issues-page">
  <div class="page-header">
    <h2>Content Issues</h2>

    <div class="header-controls">
      <p-dropdown
        [options]="sourceOptions"
        [(ngModel)]="selectedSource"
        (onChange)="onSourceChange()"
        styleClass="source-dropdown"
      ></p-dropdown>

      <p-dropdown
        [options]="statusOptions"
        [(ngModel)]="selectedStatus"
        (onChange)="onStatusChange()"
        styleClass="status-dropdown"
        placeholder="Status"
      ></p-dropdown>

      <button
        pButton
        pRipple
        icon="pi pi-refresh"
        class="p-button-rounded p-button-text"
        pTooltip="Refresh"
        [loading]="isLoading"
        (click)="loadIssues()"
      ></button>

      <button
        pButton
        pRipple
        icon="pi pi-plus"
        label="Add"
        class="p-button-sm"
        (click)="openReportIssue()"
      ></button>

      <div class="week-nav">
        <button
          pButton
          pRipple
          icon="pi pi-chevron-left"
          class="p-button-rounded p-button-text"
          pTooltip="Previous week"
          (click)="prevWeek()"
        ></button>
        <span class="week-label">{{ weekLabel }}</span>
        <button
          pButton
          pRipple
          icon="pi pi-chevron-right"
          class="p-button-rounded p-button-text"
          pTooltip="Next week"
          [disabled]="isCurrentWeek"
          (click)="nextWeek()"
        ></button>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="loading-container">
    <p-progressSpinner strokeWidth="4"></p-progressSpinner>
  </div>

  <div *ngIf="!isLoading" [class]="agGridTheme" style="width: 100%; height: calc(100vh - 160px);">
    <ag-grid-angular
      style="width: 100%; height: 100%;"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowData]="filteredRowData"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
      (cellValueChanged)="onStatusChanged($event)"
    ></ag-grid-angular>
  </div>
</div>

<app-report-issue [(visible)]="reportIssueVisible"></app-report-issue>
